var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useCallback, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { styled } from 'styled-components';
import { CreateAssignmentForm } from './components/CreateAssignmentForm';
import { useAssignmentFormInfo } from '../../hooks/useAssignmentFormInfo';
import { useLazyDetailedAssignment } from '../../hooks/useLazyDetailedAssignment';
import { getFormDataFromAssignment } from './utils';
import { CreateAssignmentPreloader } from './components/Preloader';
import { useAppGoogleAnalytics } from '../../../../../shared_app/hooks/useAppGoogleAnalytics';
import { ASSIGNMENTS_EVENTS, ASSIGNMENTS_EVENT_CATEGORIES, } from '../../constants/analytics';
var Container = styled.div.withConfig({ displayName: "Container", componentId: "sc-1h34fmv" })(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n  gap: 24px 0;\n"], ["\n  display: flex;\n  flex-direction: column;\n  gap: 24px 0;\n"])));
var CreateAssignment = function (_a) {
    var groupId = _a.groupId;
    var _b = useParams(), assignmentId = _b.assignmentId, studentId = _b.studentId;
    var formInfo = useAssignmentFormInfo(groupId).response;
    var _c = useState({}), initFormData = _c[0], setInitFormData = _c[1];
    var fetchAssignment = useLazyDetailedAssignment(groupId)[0];
    var ga = useAppGoogleAnalytics();
    var handleSubmitClick = useCallback(function () {
        ga === null || ga === void 0 ? void 0 : ga.sendEventAsTeacher({
            category: ASSIGNMENTS_EVENT_CATEGORIES.createAssignmentPage,
            action: ASSIGNMENTS_EVENTS.assign_add_assignment_page_complete_click,
        });
    }, [ga]);
    useEffect(function () {
        if (assignmentId && formInfo) {
            var getAssignment = function () { return __awaiter(void 0, void 0, void 0, function () {
                var response, initData;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, fetchAssignment(Number(assignmentId))];
                        case 1:
                            response = _a.sent();
                            if (response) {
                                initData = getFormDataFromAssignment({
                                    assignment: response.data,
                                    formInfo: formInfo,
                                    singleStudentId: Number(studentId),
                                });
                                setInitFormData(initData);
                            }
                            return [2 /*return*/];
                    }
                });
            }); };
            getAssignment();
        }
    }, [assignmentId, fetchAssignment, formInfo, studentId]);
    var isDataLoading = !formInfo ||
        (assignmentId && !initFormData.skills) ||
        (studentId && !initFormData.students);
    if (isDataLoading)
        return _jsx(CreateAssignmentPreloader, {}, void 0);
    return (_jsx(Container, { children: _jsx(CreateAssignmentForm, { groupId: groupId, formInfo: formInfo, initData: initFormData, onSubmit: handleSubmitClick }, void 0) }, void 0));
};
export { CreateAssignment };
var templateObject_1;
